<template>
    <div class="form-table-th"
         :class="{'form-table-th__sortable': sortable, 'form-table-th__sorted': sorted}"
         :style="styleObject"
         :tabindex="tabindex"
         @click.stop.prevent="onClick">
        <div class="form-table-th__text">
            <slot>{{ text }}</slot>
        </div>
        <div class="form-table-th__img" v-if="src" style="width: 24px; height: 24px;">
            <img :src="src" style="width: 24px; height: 24px;">
        </div>
        <div class="form-table-th__sort-img mr-2" v-if="sortable" :class="{'not-sorted': !sorted, 'sort-down': sortDown}" style="width: 24px; height: 24px;">
            <img :src="require('./arrow_up_grey_color.svg')" v-show="sorted" style="width: 24px; height: 24px;">
        </div>
    </div>
</template>

<script>
    export default {
        name: "TableTh",
        props: {
            text: {
                type: String,
                default: "",
            },
            align: {
                type: String,
                default: "center",
            },
            tabindex: {
                type: Number,
                default: undefined, // Default 로는 focus 가능한 요소가 아님
            },
            sortable: {
                type: Boolean,
                default: false,
            },
            // 현재 sort 가 이 헤더를 기준으로 이루어 지고 있는지 여부입니다.
            sorted: {
                type: Boolean,
                default: false,
            },
            src: {
                type: String,
                default: "",
            },
            /** true 이면 sort 시 desc 로 먼저 sorting 합니다. */
            sortDesc: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                sortDown: false,
            };
        },
        created() {
            this.initSortDirection();
        },
        mounted() {
            this.initSortDirection();
        },
        computed: {
            styleObject() {
                return {
                    justifyContent: this.justifyContent,
                    alignItmes: this.alignItmes,
                }
            },
        },
        watch: {
            sorted(newValue) {
                if (!newValue) {
                    this.sortDown = this.sortDesc ? true : false;
                }
            },
        },
        methods: {
            /**
             * 초기 sorting 방향을 결정합니다.
             */
            initSortDirection() {
                this.sortDown = this.sortDesc ? true : false;
                  if (this.sortDesc) {
                      this.sortDown = true;
                  } else {
                      this.sortDown = false;
                  }
            },

            onClick() {
                if (!this.sortable) return;

                if (!this.sorted) {
                    this.sortDown = this.sortDesc ? true : false;
                    this.sortDesc ? this.$emit('sort:down') : this.$emit('sort:up');
                    return;
                }

                if (this.sortDown) {
                    this.sortDown = false;
                    this.sortDesc ? this.$emit('sort:up') : this.$emit('sort:origin');
                    return;
                }

                if (!this.sortDown) {
                    this.sortDown = true;
                    this.sortDesc ? this.$emit('sort:origin') : this.$emit('sort:down');
                    return;
                }
            },
        },
    }
</script>

<style scoped>
    .form-table-th {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: .5rem .3rem;
        user-select: none;
    }

    .form-table-th__sortable {
        cursor: pointer;
    }

    .form-table-th__sortable:hover,
    .form-table-th__sortable.form-table-th__sorted {
        font-weight: bold !important;
    }

    .form-table-th__text {
        flex-grow: 1;
        text-align: center;
    }

    .form-table-th__sort-img {
        flex-grow: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 18px;
        height: 38px;
    }

    .form-table-th__sort-img >img {
        width: 100%;
    }

    .form-table-th__sort-img.not-sorted {
        opacity: .5;
    }

    .form-table-th__sort-img img {
        transition: transform .3s ease-in-out;
    }

    .form-table-th__sort-img.sort-down img {
        transform: rotate(-180deg);
    }

    .form-table__header__tr:hover .form-table-th__sort-img img,
    .form-table-th:hover .form-table-th__sort-img img {
        display: block !important;
    }
</style>